export const CONFIG = {
    API_URL: 'https://directory-api.sadhrasya.in',
    TOKEN_KEY: 'atkn'
}

export enum ROLES {
    'ADMIN' = 'ADMIN',
    'EMPLOYEE' = 'EMPLOYEE',
    'HR' = 'HR'
}